import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../modules/Sidebar";
import AppHeader from "../modules/Header";
import "../assets/scss/style.scss";
import { Layout } from "antd";
import { Helmet } from "react-helmet";
import { useEffect, useRef, useState } from "react";
import { useChatUserStore, useUserSelfStore } from "../store/apis/useUserStore";
import MessageSearchSection from "../sections/MessageSearchSection";
import { useBridgeStore } from "../store/apis/useBridgeStore";

const { Header: AntHeader, Sider, Content } = Layout;

const MainLayout = () => {
    const [userData,setuserData] = useState(() => JSON.parse(localStorage.getItem("userData") || "{}"));
    const navigate = useNavigate();
    const globalSectionConfig = useBridgeStore(
      (state) => state.globalSectionConfig
    );
    const setGlobalSectionConfig = useBridgeStore((store)=>store.setGlobalSectionConfig)
  
  
  const hasRunRef = useRef(false); // to ensure effect runs only once

    useEffect(() => {
      if (hasRunRef.current) return; // prevent multiple runs
      hasRunRef.current = true;
  
  
      // Conditionally add 'admin-user' class
      const path = window.location.pathname;
      const isAdminRoute = path.startsWith("/admin");
      const isAdminRole = userData?.roleName === "Admin"||userData?.roleName === "SuperAdmin";;
  
      if (isAdminRoute && isAdminRole) {
        document.body.classList.add("admin-user");
        
        setTimeout(() => {
          document.body.classList.add("load-content");
        },250)
      } else {
        document.body.classList.remove("admin-user");
         setTimeout(() => {
          document.body.classList.remove("load-content");
        },0)
        if (document.body.classList.length === 0) {
          document.body.removeAttribute("class");
        }
      }
    }, [ userData]);

    const getUserSelfDetails = useUserSelfStore(
      (store) => store.getUserSelfDetails
    );
    const getChatUserDetails = useChatUserStore(
      (store) => store.getChatUserDetails
    );

    const getChannelDetails=useChatUserStore(
      (store)=>store.getChannelDetails
    )

    
  
    useEffect(() => {
      console.log('TestCondt','1');
      
      if (userData) {
        console.log('TestCondt','2');
        
        getUserSelfDetails(userData._id);
        // getChatUserDetails(userData._id)
      }

    }, []);

  // Global ESC handler: close overlays first; if none open, go to welcome
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key !== "Escape") return;

      const hasOpenOverlay = document.querySelector(
        ".ant-modal-wrap, .ant-drawer-open, .ant-dropdown-open, .ant-popover, .ant-select-dropdown, .ant-picker-dropdown, .ant-message-notice, .ant-notification"
      );

      if (hasOpenOverlay) {
        return; // let the active overlay handle ESC
      }

      const domain = userData?.domain || userData?.companyName || "elsnertech";
      navigate(`/${domain}/welcome`);
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [navigate, userData]);
  
  return (
    <>
      <Helmet>
        <title>Welcome to Elsner e-Connect Portal</title>
      </Helmet>

      <Layout className="app-wrapper">
        <AntHeader className="header">
          <AppHeader />
        </AntHeader>

        <Layout className="app-body-wrapper">
          <Sider className="sidebar" width={250}>
            <Sidebar />
          </Sider>

          <Content className="app-body">
            <div className="app-content-wrapper">
              <Outlet />
              {globalSectionConfig.openedSection == "MessageSearchSection" && (
                <MessageSearchSection
                  isExpanded={globalSectionConfig.isExpanded}
                  onSectionUpdate={setGlobalSectionConfig}
                />
              )}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
